import * as actions from './vendorMaster/actions'
import * as mutations from './vendorMaster/mutations'
import * as getters from './vendorMaster/getters'

import { dataProps } from './vendorMaster/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'vendor_name',
        sort_direction: 0, search_term: '', 
search_term_array: []
    },
    autocomplete_list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    statement: {
        date_range: ['', ''],
        list: []
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorMaster.js